import { Component } from '@angular/core';
import { OEP_ENTITY, OEP_FILE_CATEGORY, type OEPTask } from 'agu_oep_core';
import { OEPViewBase } from '../../state/oep-view-base';
import { OEPDataService } from '../../data/oep-data.service';
import { BuildDoneItems, BuildHomeVM, type OEPHomeVM } from './home.vm';

/** Home ("Needs you now") — markup.html:202-299. All copy and rules live in home.vm.ts (pure, spec'd). */
@Component({
    standalone: false,
    selector: 'oep-home',
    templateUrl: './oep-home.component.html',
    styleUrl: './oep-home.component.scss',
})
export class OEPHomeComponent extends OEPViewBase {
    VM: OEPHomeVM | null = null;

    protected async Load(): Promise<void> {
        const snapshot = this.Context.Snapshot;
        const season = this.Context.Season;
        if (!snapshot || !season) return;
        const uploads = await this.UploadDates(season.ID);
        const done = BuildDoneItems({ Snapshot: snapshot, DraftAt: uploads.Draft, FinalAt: uploads.Final });
        this.VM = BuildHomeVM({
            FirstName: this.Context.Me.FirstName, Now: new Date(), Snapshot: snapshot,
            Tasks: this.Context.Tasks, Resources: this.Context.Resources, Done: done,
        });
    }

    /** When the presenter's draft/final files were created (MJ: Files, RLS-scoped; same link filter as OEPContextService). */
    private async UploadDates(seasonID: string): Promise<{ Draft: Date | null; Final: Date | null }> {
        if (!this.Context.Snapshot?.Presenter) return { Draft: null, Final: null };
        const me = OEPDataService.G(this.Context.Me.UserID);
        const sid = OEPDataService.G(seasonID);
        const files = await this.Data.Rows<{ Category: string; __mj_CreatedAt: string }>(
            OEP_ENTITY.Files,
            `Status='Uploaded' AND ID IN (SELECT FileID FROM __mj.FileEntityRecordLink WHERE EntityID = (SELECT ID FROM __mj.Entity WHERE Name = '${OEP_ENTITY.Presentations}') AND TRY_CONVERT(UNIQUEIDENTIFIER, RecordID) IN (SELECT ID FROM FeedbackPlatform.Presentation WHERE PresenterUserID='${me}' AND SeasonID='${sid}'))`,
            ['Category', '__mj_CreatedAt'], '__mj_CreatedAt DESC');
        const latest = (category: string): Date | null => {
            const f = files.find((x) => x.Category === category);
            return f ? new Date(f.__mj_CreatedAt) : null;
        };
        return { Draft: latest(OEP_FILE_CATEGORY.Draft), Final: latest(OEP_FILE_CATEGORY.Final) };
    }

    Open(t: OEPTask): void {
        this.Go(t.View);
    }
}
